import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import HorizontalBarChart from '../core/HorizontalBarChart';
import { Playground } from 'docz';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "horizontal-bar-chart-example-with-different-colors-and-click-event"
    }}>{`Horizontal bar chart example with different colors and click event`}</h1>
    <h2 {...{
      "id": "demo"
    }}>{`Demo`}</h2>
    <Playground __position={0} __code={'<HorizontalBarChart\n  boldTickLabel\n  showTickInfos\n  marginLeftTitle=\"50%\"\n  title=\"RYG graph\"\n  xType=\"time\"\n  onClickBar={item => window.alert(item.data.value)}\n  tooltip={{\n    label: \'Criticity\',\n    result: \'Amount (percentage)\',\n  }}\n  data={[\n    {\n      label: \'A\',\n      result: 75.3,\n      style: { color: \'red\' },\n      itemId: \'c\',\n    },\n    {\n      label: \'B\',\n      result: 86,\n      style: { color: \'yellow\' },\n      itemId: \'b\',\n    },\n    {\n      label: \'C\',\n      result: 94,\n      style: { color: \'green\' },\n      itemId: \'c\',\n    },\n  ]}\n/>'} __scope={{
      props,
      DefaultLayout,
      HorizontalBarChart,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <HorizontalBarChart boldTickLabel showTickInfos marginLeftTitle="50%" title="RYG graph" xType='time' onClickBar={item => window.alert(item.data.value)} tooltip={{
        label: 'Criticity',
        result: 'Amount (percentage)'
      }} data={[{
        label: 'A',
        result: 75.3,
        style: {
          color: 'red'
        },
        itemId: 'c'
      }, {
        label: 'B',
        result: 86,
        style: {
          color: 'yellow'
        },
        itemId: 'b'
      }, {
        label: 'C',
        result: 94,
        style: {
          color: 'green'
        },
        itemId: 'c'
      }]} mdxType="HorizontalBarChart" />
    </Playground>
    <h1 {...{
      "id": "horizontal-bar-chart-example-with-radius-border"
    }}>{`Horizontal bar chart example with radius border`}</h1>
    <h2 {...{
      "id": "demo-1"
    }}>{`Demo`}</h2>
    <Playground __position={1} __code={'<HorizontalBarChart\n  xComplement=\"%\"\n  color=\"#8BC34A\"\n  title=\"horizontal chart\"\n  toolboxTooltip={{ saveAsImage: \'save as image\' }}\n  tooltip={{\n    label: \'Equipment\',\n    result: \'Reliability\',\n  }}\n  data={[\n    { label: \'equipment 01\', result: 2 },\n    { label: \'equipment 02\', result: 40 },\n    { label: \'equipment 03\', result: 30 },\n    { label: \'equipment 04\', result: 20 },\n    { label: \'equipment 05\', result: 40 },\n    { label: \'equipment 06\', result: 50 },\n    { label: \'equipment 07\', result: 15 },\n    { label: \'equipment 08\', result: 70 },\n    { label: \'equipment 09\', result: 80 },\n    { label: \'equipment 10\', result: 99 },\n  ]}\n/>'} __scope={{
      props,
      DefaultLayout,
      HorizontalBarChart,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <HorizontalBarChart xComplement='%' color='#8BC34A' title='horizontal chart' toolboxTooltip={{
        saveAsImage: 'save as image'
      }} tooltip={{
        label: 'Equipment',
        result: 'Reliability'
      }} data={[{
        label: 'equipment 01',
        result: 2
      }, {
        label: 'equipment 02',
        result: 40
      }, {
        label: 'equipment 03',
        result: 30
      }, {
        label: 'equipment 04',
        result: 20
      }, {
        label: 'equipment 05',
        result: 40
      }, {
        label: 'equipment 06',
        result: 50
      }, {
        label: 'equipment 07',
        result: 15
      }, {
        label: 'equipment 08',
        result: 70
      }, {
        label: 'equipment 09',
        result: 80
      }, {
        label: 'equipment 10',
        result: 99
      }]} mdxType="HorizontalBarChart" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      